module.exports = __webpack_public_path__ + "static/media/49.a68b3113.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/49.png
// module id = 473
// module chunks = 0